import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { faPlane } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-airports-deropdown',
  templateUrl: './airports-deropdown.component.html',
  styleUrls: ['./airports-deropdown.component.scss']
})
export class AirportsDeropdownComponent implements OnInit {
  @Input() formCtrlName!: any;
  @Input() readonly: boolean = false;
  @Input() formGrp!: FormGroup;
  @Input() selectedAirport = ''
  @Input() placeholder = 'Departing From?'
  @Output() keyupEnter = new EventEmitter<any>();
  icons = {

    planeUp: faPlane
  }

  constructor() { }

  ngOnInit(): void {

  }

  sendInput(input: any) {
    if (input.target.value) {
      // this.keyupEnter.emit(input.target.value);
      // return (this.value = null);
    }
  }

}
